import { addTmsTrackingForChooseMyStoreButton } from "./tracking-tms";
import { initContextPopover } from "./context-popover";
import { initValidContextPopover } from "./valid-context-popover";
export function addContextBannerEvent() {
  const contextBannerSelectors = document.querySelectorAll(`[data-selectorid='context-banner']`);
  contextBannerSelectors.forEach(contextBannerSelector => {
    const postcodeBannerSelector = contextBannerSelector.querySelector(".js-context-postcode-button");
    const storeHeaderSelector = contextBannerSelector.querySelector(".js-context-store-name-button");
    const openContextLayerEvent = new CustomEvent("openStoreContextLayer", {
      detail: {
        funnel_name: "Header"
      }
    });
    const isBuM = contextBannerSelector.getAttribute("data-bum") === "true";
    if (!isBuM) {
      initContextPopover();
      initValidContextPopover();
    }
    postcodeBannerSelector?.addEventListener('click', () => {
      addTmsTrackingOnContextBanner();
      window.dispatchEvent(openContextLayerEvent);
    });
    storeHeaderSelector?.addEventListener('click', () => {
      addTmsTrackingOnContextBanner();
      window.dispatchEvent(openContextLayerEvent);
    });
  });
}
function addTmsTrackingOnContextBanner() {
  addTmsTrackingForChooseMyStoreButton("Choose my store", "Contextualisation", "Header");
}